function cov_25x0yrk7h1() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Equal.tsx";
  var hash = "316fab378dd8193d028c9efc2ea89f46204d88a5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Equal.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "316fab378dd8193d028c9efc2ea89f46204d88a5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25x0yrk7h1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_25x0yrk7h1();
var Icon = (cov_25x0yrk7h1().s[0]++, {
  name: 'equal',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.25 9C19.25 9.69036 18.6904 10.25 18 10.25L6 10.25C5.30964 10.25 4.75 9.69036 4.75 9C4.75 8.30964 5.30964 7.75 6 7.75L18 7.75C18.6904 7.75 19.25 8.30964 19.25 9Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.25 16C19.25 16.6904 18.6904 17.25 18 17.25H6C5.30964 17.25 4.75 16.6904 4.75 16C4.75 15.3096 5.30964 14.75 6 14.75L18 14.75C18.6904 14.75 19.25 15.3096 19.25 16Z\" fill=\"currentColor\"/>"
});
export default Icon;